import React__default from 'react';
import styled from 'styled-components';
import sx from '../../sx.js';
import { themeGet } from '../../utils/theme-get.js';
import Box from '../Box/Box.js';
import Button from '../Button/Button.js';
import Text from '../Text/Text.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// Root
// ------------------------
const Wrapper = styled(Box).withConfig({
  displayName: "HelpRequest__Wrapper",
  componentId: "sc-8vaovd-0"
})(["display:flex;align-items:center;justify-content:flex-end;width:100%;"]);
const StyledHelpButton = styled(Button).withConfig({
  displayName: "HelpRequest__StyledHelpButton",
  componentId: "sc-8vaovd-1"
})(["appearance:none;margin:0;padding:0;border:none;background:transparent;cursor:pointer;text-align:left;font:inherit;display:inline-block;color:", ";font-size:", ";text-decoration:none;opacity:0.85;font-weight:", ";padding:10px 12px;border-radius:", ";&:hover,&:focus{opacity:1;text-decoration:none;color:", ";background-color:", ";}&:active{opacity:1;text-decoration:none;background-color:", ";color:", ";}&:focus,.focus-visible{outline:none;transition-duration:0s,0.2s;box-shadow:0 0 0 2px ", ";}&:focus:not(:focus-visible):not(.focus-visible){box-shadow:0 0 0 2px ", ";}", ""], themeGet('colors.link.pressed'), themeGet('fontSizes.3'), themeGet('fontWeights.semibold'), themeGet('radii.1'), themeGet('colors.link.pressed'), themeGet('colors.background.neutral.subtle.default'), themeGet('colors.background.selected.default.[default]'), themeGet('colors.text.selected'), themeGet('colors.border.focused'), themeGet('colors.border.focused'), sx);
/**
 * Displays a help request, link that can be an href or a route, and an optional trailing visual
 */
const HelpRequest = ({
  children,
  defaultValue = "Can't find what you need?",
  trailingVisual: TrailingVisual,
  ...props
}) => {
  const hasTrailingVisual = Boolean(TrailingVisual);
  return /*#__PURE__*/React__default.createElement(Wrapper, null, /*#__PURE__*/React__default.createElement(Text, null, defaultValue), children, hasTrailingVisual ? /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      color: 'icon.information'
    }
  }, typeof TrailingVisual === 'function' ? /*#__PURE__*/React__default.createElement(TrailingVisual, null) : TrailingVisual) : null);
};
HelpRequest.displayName = "HelpRequest"; // Help Link
// ------------------------
/**
 * Navigation link item for the Help Request
 */
const Link = ({
  children,
  href,
  onSelect,
  ...props
}) => {
  if (href && onSelect) {
    throw new Error(`Help request links take an onSelect or an href prop, but not both. See: https://fuegokit.design/react-storybook/patterns/rule-builder.`);
  }
  if (href) {
    return /*#__PURE__*/React__default.createElement(StyledHelpButton, _extends({
      href: href
    }, props), children);
  }
  if (onSelect) {
    return /*#__PURE__*/React__default.createElement(StyledHelpButton, _extends({
      onClick: onSelect
    }, props), children);
  }
  throw new Error(`Provide HelpRequest.Link an onSelect or an href prop. See: https://fuegokit.design/react/patterns/global-header.`);
};

// const StyledHelpLink = styled(FuegokitLink)<HelpLinkProps & LinkProps & SxProp>`
//   appearance: none;
//   margin: 0;
//   padding: 0;
//   border: none;
//   background: transparent;
//   cursor: pointer;
//   text-align: left;
//   font: inherit;

//   display: inline-block;
//   color: ${themeGet('colors.link.pressed')};
//   font-weight: normal;
//   font-size: ${themeGet('fontSizes.2')};
//   text-decoration: none;
//   opacity: 0.85;
//   font-weight: ${themeGet('fontWeights.bold')};
//   padding: 10px 12px;
//   border-radius: ${themeGet('radii.1')};
//   &:hover,
//   &:focus {
//     opacity: 1;
//     text-decoration: none;
//     color: ${themeGet('colors.link.pressed')};
//     background-color: ${themeGet('colors.background.neutral.subtle.hovered')};
//   }
//   &:active {
//     opacity: 1;
//     text-decoration: none;
//     background-color: ${themeGet('colors.background.selected.default.[default]')};
//     color: ${themeGet('colors.text.selected')};
//   }
//   &:focus,
//   .focus-visible {
//     outline: none;
//     transition-duration: 0s, 0.2s;
//     box-shadow: 0 0 0 2px ${themeGet('colors.border.focused')};
//   }
//   &:focus:not(:focus-visible):not(.focus-visible) {
//     box-shadow: 0 0 0 2px ${themeGet('colors.border.focused')};
//   }
//   ${sx}
// `

HelpRequest.displayName = 'HelpRequest';
Link.displayName = 'HelpRequest.Link';
var HelpRequest$1 = Object.assign(HelpRequest, {
  Link
});

export { HelpRequest$1 as default };
